import emitter from '@/shared/services/emitter';
import { useUserStore } from '@/shared/store/useUserStore';
// @ts-ignore
import router from '@project/router';
import {
  RouteLocationRaw,
  RouteRecord,
} from 'vue-router';
import { watch } from 'vue';
import { callAfterAppReady } from '@/callAfterAppReady';
import { debug } from 'debug';

const localDebug = debug('app:userHasPhoneGuard');

const guardFn = (to: any, from: any, next: any) => {
  const userStore = useUserStore();
  if (!userStore.getUserInfo.isFetched) {
    localDebug('user is fetched');
    next();
    watch(() => userStore.isFetched, () => {
      _userHasPhoneGuard(to, (location: RouteLocationRaw) => {
        localDebug('redirect location', location, to);
        if (location && !window.location.href.includes('/get-card')) {
          router.push(location);
        }
      });
    });
    return;
  }

  // @ts-ignore
  _userHasPhoneGuard(to, next);
};

export function userHasPhoneGuard() {
  callAfterAppReady(() => {
    localDebug('before router');
    (router as any).beforeEach(guardFn);
    guardFn(router.currentRoute, {}, (location: RouteLocationRaw) => {
      if (location) {
        router.push(location);
      }
    });
  });
}

function _userHasPhoneGuard(to: RouteRecord, next: any) {
  const userStore = useUserStore();
  const hasCard = userStore.hasActivePhysicalUserCard;

  localDebug('user has card', hasCard);
  if (hasCard) {
    next();
    return;
  }

  localDebug('to route', to);
  if (to.name === 'GetCard') {
    next();
    return;
  }

  emitter.emit('createToast', {
    message: 'Необходимо заполнить данные для карты',
    color: 'error',
  });
  next({ name: 'GetCard' });
}
